import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Paper, Typography } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BuildIcon from '@mui/icons-material/Build';
import PhoneIcon from '@mui/icons-material/Phone';
import { SectionTitle } from '../Styles/StylesComponents';

const shake = keyframes`
  0% { transform: rotate(0deg); }
  25% { transform: rotate(15deg); }
  50% { transform: rotate(0deg); }
  75% { transform: rotate(-15deg); }
  100% { transform: rotate(0deg); }
`;

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
`;

const Container = styled.div`
  padding: 40px 20px;
  max-width: 1200px;
  margin: 0 auto;
  border-radius: 12px;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
  padding: 20px 0;
  
  @media (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
  
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const InfoCard = styled(Paper)`
  padding: 30px 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: all 0.3s ease;
  border-radius: 12px !important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15) !important;
  }
`;

const IconWrapper = styled.div<{ $iconType: string }>`
  background: var(--primary-color);
  margin-bottom: 20px;
  padding: 15px;
  background-color: rgba(229, 57, 53, 0.1);
  border-radius: 50%;
  
  .MuiSvgIcon-root {
    font-size: 45px;
    animation: ${props => {
      switch(props.$iconType) {
        case 'home':
          return pulse;
        case 'phone':
          return shake;
        case 'build':
          return pulse;
        case 'time':
          return shake;
        default:
          return 'none';
      }
    }} 2s infinite;
  }
`;

const InfoTitle = styled(Typography)`
  color: var(--text-title);
  font-weight: 600 !important;
  margin-bottom: 20px !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const Information = () => {
  return (
    <Container>
      <SectionTitle>THÔNG TIN CHUNG</SectionTitle>
      <GridContainer>
        <InfoCard elevation={2}>
          <IconWrapper $iconType="home">
            <HomeIcon />
          </IconWrapper>
          <InfoTitle variant="h6">ĐỊA CHỈ</InfoTitle>
          <Typography variant="body2">
            Số 06, Đường DN6, KDC AN SƯƠNG,
            <br />
            P. TÂN HƯNG THUẬN, Q. 12
          </Typography>
        </InfoCard>

        <InfoCard elevation={2}>
          <IconWrapper $iconType="time">
            <AccessTimeIcon />
          </IconWrapper>
          <InfoTitle variant="h6">THÔNG TIN CÔNG TY</InfoTitle>
          <Typography variant="body2">
            CÔNG TY TNHH THƯƠNG MẠI DỊCH VỤ GIA PHÁT AUTO
            <br />
            MST: 0316563009
            <br />
            Email: ctygiaphatauto@gmail.com
          </Typography>
        </InfoCard>

        <InfoCard elevation={2}>
          <IconWrapper $iconType="build">
            <BuildIcon />
          </IconWrapper>
          <InfoTitle variant="h6">LIÊN HỆ</InfoTitle>
          <Typography variant="body2">
            Hotline: 0913169066
            <br />
            Email: ctygiaphatauto@gmail.com
          </Typography>
        </InfoCard>

        <InfoCard elevation={2}>
          <IconWrapper $iconType="phone">
            <PhoneIcon />
          </IconWrapper>
          <InfoTitle variant="h6">CỨU HỘ 24/24</InfoTitle>
          <Typography variant="h5" style={{ color: '#0d6efd', fontWeight: 'bold' }}>
            0913.169.066
          </Typography>
        </InfoCard>
      </GridContainer>
    </Container>
  );
};

export default Information;